<script>
import 'regenerator-runtime/runtime';

const axios = require('axios');

export default {
  name: 'ViewMoreCards',
  props: {
    url: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      domCardsList: null,
      buttonIsEnabled: true,
      newUrl: null,
      loading: null,
      disabled: null,
      timeoutId: null,
    };
  },
  mounted() {
    if (!this.url) {
      this.buttonIsEnabled = false;
    } else {
      this.newUrl = this.url;
      this.domCardsList = this.$el.querySelector('.cards-grid__list');
    }
  },
  methods: {
    handleSetTimeout() {
      this.loading = true;
      clearTimeout(this.timeoutId);
    },
    async viewMoreCards() {
      this.disabled = true;

      try {
        this.timeoutId = setTimeout(this.handleSetTimeout, 300);
        const response = await axios.get(this.newUrl);
        this.loading = false;
        this.disabled = false;
        clearTimeout(this.timeoutId);
        const { data } = response;

        if (data.cards) {
          data.cards.forEach((card) => {
            this.domCardsList.insertAdjacentHTML('beforeend', card);
          });

          if (data.buttonUrl) {
            this.newUrl = data.buttonUrl;
          } else {
            this.buttonIsEnabled = false;
          }
        }
      } catch (error) {
        console.error(error);
        this.loading = false;
        this.disabled = false;
      }
    },
  },
};
</script>
